import { phoneNumberOption } from "@/helpers/cleavePlugin";
import { validPhoneNumber } from "@/helpers/validation";

describe("Australian phone numbers", () => {
  it.each([
    "0400 000 000",
    "1300 000 000",
    "1800 000 000",
    "01 0000 0000",
    "02 0000 0000",
    "03 0000 0000",
    "07 0000 0000",
    "08 0000 0000",
    "+61 400 000 000",
    "+61 2 0000 0000",
  ])("accepts %s", (phoneNumber) => {
    expect(validPhoneNumber(phoneNumber)).toBe(true);
  });

  it.each([
    "13 0000 0000",
    "1300 000 00",
    "1800 000 0000",
    "00 0000 0000",
    "not a phone number",
  ])("rejects %s", (phoneNumber) => {
    expect(validPhoneNumber(phoneNumber)).toBe(false);
  });

  it.each([
    ["0400000000", [4, 3, 3]],
    ["1300000000", [4, 3, 3]],
    ["1800000000", [4, 3, 3]],
    ["0100000000", [2, 4, 4]],
    ["0200000000", [2, 4, 4]],
    ["0700000000", [2, 4, 4]],
    ["+61400000000", [3, 3, 3, 3]],
    ["+61200000000", [3, 1, 4, 4]],
  ])("formats %s using the expected blocks", (phoneNumber, blocks) => {
    expect(phoneNumberOption(phoneNumber as string).blocks).toEqual(blocks);
  });
});
